import styled from 'styled-components';
import PlainArrow from '../../assets/images/plain-arrow-icon.svg';

const PlainArrowIconRight = styled.span`
  background: url(\"${PlainArrow}\") no-repeat left center;
  background-size: 10px 10px;
  display: inline-block;
  position: relative;
  height: 10px;
  width: 10px;
  margin-right: 10px;
  transform: rotate(0);
  &.ArrowDown {
    transform: rotate(180deg);
  }
  &.ArrowUp {
    transform: rotate(0);
  }
`;

export default PlainArrowIconRight;
